import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import type { ActiveSeat } from '../../../models/subscription';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

/**
 * Keyed by the current organization even when no id is passed.
 *
 * The request is scoped by the `X-Organization-ID` header, so without the id in the
 * key every organization shared one cache entry and the page showed the previously
 * opened organization's numbers for the whole staleTime. Same fix as useSubscription.
 */
export const useActiveSeats = (explicitOrganizationId?: string) => {
  const currentOrganizationId = useAppSelector(
    (state: RootState) => state.organization.organizationId,
  );
  const organizationId = explicitOrganizationId ?? currentOrganizationId;

  return useQuery<ActiveSeat[], Error>({
    queryKey: ['activeSeats', organizationId],
    queryFn: () => subscriptionService.getActiveSeats(explicitOrganizationId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
    enabled: !!organizationId,
  });
};
